module.exports = __webpack_public_path__ + "static/media/atom.1ca631b3.png";